import React from 'react';
import styles from './RowData.module.css';

const RowData = ({ room, inCount, outCount, pendingCount  }) => {
  return (
    <div className={styles.row}>
      <span >{room}</span>
      <span>{inCount}</span>
      <span>{outCount}</span>
      <span>{pendingCount}</span>
    </div>
  );
};

export default RowData;
